import { Account } from 'pages/account';
import { AlbumInvite } from 'pages/album-invite';
import { Invitation } from 'pages/invitation';
import { AgoraVideoCall } from 'pages/agora-video-call';
import { VaultDetail } from 'pages/vault-detail';
import { VaultDetailGuest } from 'pages/vault-detail-guest';
import { VaultImport } from 'pages/vault-import';
import { MoveMemories } from 'pages/move-memories';
import { DropboxCallback } from 'pages/dropbox-callback';
import { VaultNew } from 'pages/vault-new';
import { VaultReminder } from 'pages/vault-reminder';
import { VaultSettings } from 'pages/vault-settings';
import { Vaults } from 'pages/vaults';
import { ClipDetailGuest } from 'pages/clip-detail-guest';
import { Contributors } from 'pages/contributors';
import { CreateTemporaryUser } from 'pages/create-temporary-user';
import { EmailVerifying } from 'pages/email-verifying';
import { EmailWaitingConfirm } from 'pages/email-waiting-confirm';
import { ForgotPassword } from 'pages/forgot-password';
import { Home } from 'pages/home';
import { JoinVideoCallGuest } from 'pages/join-video-call-guest';
import {
  AlbumScreen,
  LegacyVaultViewMode,
  MemoriesViewScreen,
  PublicViewScreen,
} from 'pages/album-view-mode';
import { SingleAlbum } from 'pages/single-album';
import { NotFound } from 'pages/not-found';
import { StartOnboarding } from 'pages/onboarding';
import { OnboardingVaultInfo } from 'pages/onboarding-vault-info';
import { OnboardingPromptCategories } from 'pages/onboarding-prompt-categories';
import { SelectCategories } from 'pages/onboarding-select-categories';
import { OnboardingSubjectSelection } from 'pages/onboarding-subject-selection';
import { ResetPassword } from 'pages/reset-password';
import { ReviewVideosPage } from 'pages/review-videos';
import { ReviewVideosGuest } from 'pages/review-videos-guest';
import { SelfRecordingGuest } from 'pages/self-recording-guest';
import { SignIn } from 'pages/sign-in';
import { SignInOnboarding } from 'pages/sign-in-onboarding';
import { SignUp } from 'pages/sign-up';
import { SignUpIgn } from 'pages/sign-up-ign';
import { SignUpOnboarding } from 'pages/sign-up-onboarding';
import { Store } from 'pages/store';
import { Templates } from 'pages/templates';
import { UnlinkedQrCode } from 'pages/unlinked-qr-code';
import { RouteName } from 'routes/routes';

const routeConfig = [
  {
    name: RouteName.Home,
    component: Home,
  },
  {
    name: RouteName.Account,
    component: Account,
  },
  {
    name: RouteName.Templates,
    component: Templates,
  },
  {
    name: RouteName.VaultNew,
    component: VaultNew,
  },
  {
    name: RouteName.Vaults,
    component: Vaults,
  },
  {
    name: RouteName.VaultDetail,
    component: VaultDetail,
  },
  {
    name: RouteName.VaultSettings,
    component: VaultSettings,
  },
  {
    name: RouteName.VaultImport,
    component: VaultImport,
  },
  {
    name: RouteName.MoveMemories,
    component: MoveMemories,
  },
  {
    name: RouteName.DropboxCallback,
    component: DropboxCallback,
  },
  {
    name: RouteName.VaultDetailGuest,
    component: VaultDetailGuest,
  },
  {
    name: RouteName.Collaborators,
    component: Contributors,
  },
  {
    name: RouteName.JoinVideoCallGuest,
    component: JoinVideoCallGuest,
  },
  {
    name: RouteName.ClipDetailGuest,
    component: ClipDetailGuest,
  },
  {
    name: RouteName.SignIn,
    component: SignIn,
  },
  {
    name: RouteName.SignUp,
    component: SignUp,
  },
  {
    name: RouteName.EmailWaitingConfirm,
    component: EmailWaitingConfirm,
  },
  {
    name: RouteName.EmailVerifying,
    component: EmailVerifying,
  },
  {
    name: RouteName.ForgotPassword,
    component: ForgotPassword,
  },
  {
    name: RouteName.ResetPassword,
    component: ResetPassword,
  },
  {
    name: RouteName.AgoraVideoCall,
    component: AgoraVideoCall,
  },
  {
    name: RouteName.Store,
    component: Store,
  },
  {
    name: RouteName.SelfRecordingGuest,
    component: SelfRecordingGuest,
  },
  {
    name: RouteName.AlbumShareGuest,
    component: SelfRecordingGuest,
  },
  {
    name: RouteName.ReviewVideosGuest,
    component: ReviewVideosGuest,
  },
  {
    name: RouteName.UnlinkedQrCode,
    component: UnlinkedQrCode,
  },
  {
    name: RouteName.ReviewVideos,
    component: ReviewVideosPage,
  },
  {
    name: RouteName.CreateTemporaryUser,
    component: CreateTemporaryUser,
  },
  {
    name: RouteName.SignUpIgn,
    component: SignUpIgn,
  },
  {
    name: RouteName.VaultReminder,
    component: VaultReminder,
  },
  {
    name: RouteName.StartOnboarding,
    component: StartOnboarding,
  },
  {
    name: RouteName.SignUpOnboarding,
    component: SignUpOnboarding,
  },
  {
    name: RouteName.SignInOnboarding,
    component: SignInOnboarding,
  },
  {
    name: RouteName.OnboardingSubjectSelection,
    component: OnboardingSubjectSelection,
  },
  {
    name: RouteName.OnboardingVaultInfo,
    component: OnboardingVaultInfo,
  },
  {
    name: RouteName.OnboardingSelectCategories,
    component: SelectCategories,
  },
  {
    name: RouteName.OnboardingPromptSelectCategories,
    component: OnboardingPromptCategories,
  },
  {
    name: RouteName.ViewMode,
    component: LegacyVaultViewMode,
  },
  {
    name: RouteName.MemoriesViewScreen,
    component: MemoriesViewScreen,
  },
  {
    name: RouteName.AlbumViewMode,
    component: PublicViewScreen,
  },
  {
    name: RouteName.ContentViewMode,
    component: PublicViewScreen,
  },
  {
    name: RouteName.VaultViewMode,
    component: PublicViewScreen,
  },
  {
    name: RouteName.AlbumScreen,
    component: SingleAlbum,
  },
  {
    name: RouteName.AlbumViewScreen,
    component: AlbumScreen,
  },
  {
    name: RouteName.AlbumInvite,
    component: AlbumInvite,
  },
  {
    name: RouteName.Invitation,
    component: Invitation,
  },
  {
    name: RouteName.NotFound,
    component: NotFound,
  },
];

export { routeConfig };
